import { Account } from "@wingspanhq/wingspan-api-sdk";
import { queriesAccounts } from "@query";
import { useSession } from "@hooks/useSession";
import { BusinessProfile } from "../steps/BusinessProfile";
import {
  buildOnboardingStep,
  UseCreateOnboardingStep,
  useOnboardingStepQueryConfig
} from "../components/OnboardingFlowUtils";
import { selectorHasBusinessProfile } from "../selectors/selectorHasBusinessProfile";
import { OnboardingContext, OnboardingModuleBusinessProfile } from "../types";
import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const getBusinessProfileStepConfig = (
  _: OnboardingModuleBusinessProfile,
  __: OnboardingContext,
  account?: Account
): FlowStep => ({
  title: "Business profile",
  slug: "business-profile",
  component: BusinessProfile,

  // A profile the payer skipped is indistinguishable from one they never
  // reached, so the step only becomes Complete once the account carries a
  // logo or a link — the component navigates to the result screen itself.
  status: selectorHasBusinessProfile(account) ? "Complete" : "None",
  result: {
    Complete: {
      title: "Your business profile was saved",
      description:
        "Your business profile was saved and will help contractors identify your business. Click continue for the next step."
    }
  }
});

export const useBusinessProfileStep: UseCreateOnboardingStep<
  OnboardingModuleBusinessProfile
> = modules => {
  const config = useOnboardingStepQueryConfig(modules, "business_profile");
  const { accountId } = useSession();
  const queryAccount = queriesAccounts.getAccount.useQuery(
    { accountId },
    { ...config, enabled: config.enabled && !!accountId }
  );

  return (onboardingModule, contextValue) =>
    buildOnboardingStep({
      getConfig: getBusinessProfileStepConfig,
      module: onboardingModule,
      context: contextValue,
      queries: [queryAccount]
    });
};
